import { render, staticRenderFns } from "./BISamplePreview.vue?vue&type=template&id=362b3b5f"
import script from "./BISamplePreview.vue?vue&type=script&lang=js"
export * from "./BISamplePreview.vue?vue&type=script&lang=js"
import style0 from "./BISamplePreview.vue?vue&type=style&index=0&id=362b3b5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports